import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import ColumnLineChart from '../../../shared/columnLineChart';

const BeingAdsCTRChart = () => {
    // Extracting data safely with optional chaining (?.)
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch) || {};
    const { isCostApiLoading } = useSelector((state) => state.webMatrix);
    const { isPaidSearchLoading, CPCBarChart = {} } = dtcData || {};
    const { categories = [], data = [] } = CPCBarChart || {}; 
    const isLoading = ( isCostApiLoading || isPaidSearchLoading);

    // Chart options
    const options = {
        chart: {
            height: 350,
            type: 'line',
            toolbar: { show: false }
        },
        stroke: { width: [0, 4] },
        colors: ['#AD509E', '#E9BEE3'], // Custom colors for column & line
        dataLabels: { enabled: false, enabledOnSeries: [1] },
        labels: [
            '01 Jan 2001', '02 Jan 2001', '03 Jan 2001', '04 Jan 2001',
            '05 Jan 2001', '06 Jan 2001', '07 Jan 2001', '08 Jan 2001',
            '09 Jan 2001', '10 Jan 2001', '11 Jan 2001', '12 Jan 2001'
        ],
        yaxis: [
            {
                title: { text: 'Sum of Engagement' },
                labels: {
                    formatter: (value) => {
                        if (value >= 1_000_000) return Math.floor(value / 1_000_000) + 'M';
                        if (value >= 1_000) return Math.floor(value / 1_000) + 'K';
                        return value;
                    }
                }
            },
            {
                opposite: true,
                title: { text: 'CTR' },
                labels: { formatter: (value) => value + '%' }
            }
        ],
        legend: {
            show: true,
            horizontalAlign: 'left',
            position: 'top'
        }
    };

    // Chart series
    const series = [
        {
            name: 'Bing Ads',
            type: 'column',
            data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160]
        },
        {
            name: 'CTR',
            type: 'line',
            data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16]
        }
    ];

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Bing Ads CTR
                </Typography>
            </Box>

            <Box className="wh-100" id="engagement-deciles">
                {isLoading? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <ColumnLineChart height={350} options={options} series={series} type="line" />
                )}
            </Box>
        </Box>
    );
};

export default BeingAdsCTRChart;
